// hooks/useFormActions.js
import { useCallback } from "react";
import useFormConditionals from "./Conditionals";
import { HTML_FORM_CONSTANTS } from "../../util/constants";

export default function useFormActions({ 
  formRef, 
  setShowErrorFields,
  dispatchEvent
}) {
  const {
    allowSavingWithoutValidation,
    showAcceptButton
  } = useFormConditionals()
  const saveForm = useCallback(() => {
    if (allowSavingWithoutValidation) {
      dispatchEvent(HTML_FORM_CONSTANTS.INTENTS.save, formRef.current);
      return
    }
  
    const isValid = formRef.current?.reportValidity();
    setShowErrorFields(!isValid);
    if(isValid) {
      dispatchEvent(HTML_FORM_CONSTANTS.INTENTS.save, formRef.current);
    }
  }, [allowSavingWithoutValidation, dispatchEvent, formRef, setShowErrorFields]);

  const onSubmitClick = useCallback(() => {
    const isValid = formRef.current?.reportValidity();
    setShowErrorFields(!isValid);
  }, [formRef, setShowErrorFields]);

  const handleSubmit = useCallback((event) => {
    event.preventDefault();
    const isValid = event.currentTarget.reportValidity();
    if(!isValid) {
      setShowErrorFields(true);
      return;
    }
    const action = showAcceptButton 
      ? HTML_FORM_CONSTANTS.INTENTS.accept 
      : HTML_FORM_CONSTANTS.INTENTS.submit;
    dispatchEvent(action, event.currentTarget);
  }, [dispatchEvent, setShowErrorFields, showAcceptButton]);

  const handleDelete = useCallback(() => {
    dispatchEvent(HTML_FORM_CONSTANTS.INTENTS.delete, formRef.current);
  }, [dispatchEvent, formRef]);

  return {
    onSave: saveForm,
    onSubmit: handleSubmit,
    onSubmitClick: onSubmitClick,
    onDelete: handleDelete
  };
}
